<p-card header="Смена пароля" class="flex items-center justify-center p-4 cntr">

  <form [formGroup]="registerForm" (ngSubmit)="submitForm()">
    <div class="field">
      <label for="oldPasswd">Старый пароль:</label>
      <input pInputText type="password" class="form-control" formControlName="oldPasswd" id="oldPasswd">

      @if(!registerForm.get('oldPasswd')?.valid && registerForm.get('oldPasswd')?.touched) {
      <small class="error_message">Пароль не может быть меньше 6 символов</small>
      }
    </div>

    <div class="field">
      <label for="newPasswd">Новый пароль:</label>
      <input pInputText type="password" class="form-control" formControlName="newPasswd" id="newPasswd">

      @if(!registerForm.get('newPasswd')?.valid && registerForm.get('newPasswd')?.touched) {
      <small class="error_message">Пароль не может быть меньше 6 символов</small>
      }
    </div>

    <div class="field">
      <label for="newPasswd2">Новый пароль (повторно):</label>
      <input pInputText type="password" class="form-control" formControlName="newPasswd2" id="newPasswd2">

      @if(!registerForm.get('newPasswd2')?.valid && registerForm.get('newPasswd2')?.touched) {
      <small class="error_message">
        @if(registerForm.get('newPasswd2')?.errors && registerForm.get('newPasswd2')?.errors??['passwd2Mismatch'] ===
        null) {Пароли не совпадают!}
        @else {Пароль не может быть меньше 6 символов}
      </small>
      }
    </div>

    <div>
      <p-button type="submit" class="pull-right">Сменить пароль</p-button>
    </div>

  </form>

</p-card>